import { RegisterOptions } from 'react-hook-form/dist/index.ie11';

export function addAsterisk(label: string, rules?: RegisterOptions): string {
  const isRequired =
    typeof rules?.required === 'object'
      ? rules.required.value
      : !!rules?.required;

  return isRequired ? `${label} *` : label;
}
